// Route-query dashboards that take over the viewport width (calc(50vw)/full-screen etc.).
// While any of these is active the Inspection-Filter dock must fall back to float — its
// 460px gutter would otherwise overflow. Sourced from $route.query.selectedPageTitle
// (see MainView.vue showInspectionDashboard / showSisTestingDashboard / showWorkPackProgressDashboard).
export const ROUTE_DASHBOARD_TITLES = Object.freeze([
  'New Inspection Dashboard', // showInspectionDashboard
  'Activity Tracker', //         showSisTestingDashboard
  'Work Pack Tag Progress', //   showWorkPackProgressDashboard
]);

/**
 * @param {{ query?: { selectedPageTitle?: string } }} route - the Vue Router $route
 * @returns {boolean} true when a viewport-width route dashboard is active
 */
export function isRouteDashboardActive(route) {
  return ROUTE_DASHBOARD_TITLES.includes(route?.query?.selectedPageTitle);
}
